import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IInfoCenterFaq, IInfoCenterFaqs } from 'types/info-center/faq'
import { IPaginationQueryInfo } from 'types/pagination'

type IFaqPaginationQueryInfo = IPaginationQueryInfo & { keyword: string }

export const infoCenterFaqApi = createApi({
  reducerPath: 'infoCenterFaq',
  baseQuery,
  tagTypes: ['FAQ'],
  endpoints: (builder) => ({
    faq: builder.query<IInfoCenterFaqs, IFaqPaginationQueryInfo>({
      query: ({ page, size, keyword }) => {
        const params = new URLSearchParams()

        if (size) {
          params.set('size', String(size))
        }
        if (page) {
          params.set('page', String(page))
        }

        const searchByKeyword = keyword?.trim()
        if (searchByKeyword && searchByKeyword.length > 0) {
          params.set('keyword', searchByKeyword)
        }

        return {
          url: '/info-center/faq',
          method: 'get',
          params,
        }
      },
      providesTags: ['FAQ'],
    }),
    deleteFaq: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/info-center/faq/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['FAQ'],
    }),

    createFaq: builder.mutation<void, Partial<IInfoCenterFaq>>({
      query: (body) => ({
        url: `/info-center/faq`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['FAQ'],
    }),
  }),
})

export const { useFaqQuery, useDeleteFaqMutation, useCreateFaqMutation } = infoCenterFaqApi
